// removed by extract-text-webpack-plugin
module.exports = {"container":"dashboard-container__container__SgiWa","container-login":"dashboard-container__container-login__2ZBXv","grid":"dashboard-container__grid__2HP_Y","dashboard-section":"dashboard-container__dashboard-section__2uuUe"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/dashboard-container.scss
// module id = 1244
// module chunks = 1